import React from 'react';
import ClinicianCard from '../../../components/common/ClinicianCard';
import DetailRow from '../../../components/common/DetailRow';
import { Card, CardBody, SectionTitle } from '../../../components/common/Card';
import { PAYMENT_STATE_LABEL } from '../../../constants/rescheduleConstants';
import { formatAppointmentDateTimeInZone } from '../../../utils/appointmentDisplayUtils';
import {
  getAppointmentDurationMinutes,
  getPaymentState,
} from '../../../utils/rescheduleUtils';

/**
 * "Your appointment now": who, when (in the zone the slots below are shown in), how long
 * and the payment state.
 */
const CurrentAppointment = ({
  workflow,
  timezone,
  title = 'Your appointment now',
}) => {
  const { appointment, specialist, payment } = workflow || {};
  const durationMinutes = getAppointmentDurationMinutes(appointment);

  return (
    <Card>
      <CardBody>
        <SectionTitle>{title}</SectionTitle>
        <ClinicianCard specialist={specialist} />
        <DetailRow
          label="Date and time"
          value={formatAppointmentDateTimeInZone(
            appointment?.startDateTime,
            timezone
          )}
        />
        {durationMinutes && (
          <DetailRow
            label="Appointment length"
            value={`${durationMinutes} minutes`}
          />
        )}
        <DetailRow
          label="Payment"
          value={PAYMENT_STATE_LABEL[getPaymentState(payment)]}
        />
      </CardBody>
    </Card>
  );
};

export default CurrentAppointment;
